import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, rem, Skeleton } from '@bonusly/design-system';

import logo from '../../assets/images/bonusly-logo.png';
import { useCompanyProfile } from '../../hooks/useCompanyProfile';

export const CompanyLogo: FC = () => {
	const { company, isLoading } = useCompanyProfile();
	const { t } = useTranslation('navigation');

	if (isLoading) {
		return <Skeleton borderRadius="md" data-testid="logo-loading" h={rem(40)} w={rem(120)} />;
	}

	return (
		<Image
			alt={t('links.company_logo', { name: 'Bonusly' })}
			h="full"
			objectFit="contain"
			src={logo}
			{...(company?.logo_url && {
				alt: t('links.company_logo', { name: company.name }),
				src: company.logo_url,
			})}
		/>
	);
};
